import React, { useState, useEffect } from 'react';
import { Layout, Row, Col, Form, Input, Button, message, Space, Card, Radio } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useHistory } from "react-router-dom";
import { loginInfo } from '../../config';
import { doLogin } from '../../api/Api';
import styles from "./Login.module.css";
const { Header, Content } = Layout;

export const LoginPage: React.FC = () => {
  const [loginBackground, setLoginBackground] = useState(styles["login-background-43"]);
  const [cardPosition, setCardPosition] = useState({ top: 0, left: 0, width: 0, height: 0, backgroundColor: "transparent" });
  const history = useHistory();
  window.onresize = () => {
    onResize();
  }
  useEffect(() => {
    onResize();
  }, []);

  const onResize = () => {
    let width = document.body.clientWidth, height = document.body.clientHeight;
    let radio = height / width;
    let type = '';
    if (radio < 0.6) {
      type = "1609";
      setLoginBackground(styles["login-background-169"]);
    } else if (radio < 0.7) {
      type = "1610";
      setLoginBackground(styles["login-background-1610"]);
    } else {
      type = "0403";
      setLoginBackground(styles["login-background-43"]);
    }
    let posTop = 0, posLeft = 0, posWidth = 0, posHeight = 0;
    posTop = height * 0.66;
    posLeft = width * 0.63;
    posWidth = width * 0.30;
    posHeight = height * 0.25;

    setCardPosition({
      ...cardPosition,
      top: posTop,
      left: posLeft,
      width: posWidth,
      height: posHeight,
    })
  }


  const onFinish = async (values: any) => {
    let data = await doLogin(values.username, values.password, "hospital");
    if (data.status) {
      loginInfo.user = data.user;
      loginInfo.token = data.token;
      history.push("/home");
    } else {
      message.error('用户名或密码错误,登录失败!');
    }

  };

  return (
    < div className={loginBackground} >
      <Card bordered={false} style={cardPosition}>
        <Form
          name="login"          
          onFinish={onFinish}
        //onFinishFailed={onFinishFailed}
        >
          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: '用户名不能为空!',
              },
            ]}
          >
            <Input placeholder='登录名称' style={{ borderRadius: "10px" }} prefix={<UserOutlined className="site-form-item-icon" />} />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: '用户密码不能为空!',
              },
            ]}
          >
            <Input.Password placeholder='登录密码' style={{ borderRadius: "10px" }} prefix={<LockOutlined className="site-form-item-icon" />} />
          </Form.Item>


          <Form.Item
          >
            <Button size="large" type="primary" shape="round" htmlType="submit">
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div >)


};